import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { REBRANDING_LOCAL_STORAGE_KEY } from "@src/initRebranding";
// eslint-disable-next-line no-restricted-imports
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";

export function useWorkerAppRebrandingSync(): void {
  // We can't use useCbhFlag because we need to know the actual value of the flag
  // with no fallback to the default value (false)
  // Otherwise, while the flag is loading, isRebrandingEnabled would always be false,
  // which would wrongly overwrite localStorage
  //
  // tl;dr We only want to write to localStorage when we know the actual value of the flag
  const flags = useFlags();
  const isRebrandingEnabled = flags[CbhFeatureFlag.WORKER_APP_REBRANDING] as boolean | undefined;

  useEffect(() => {
    if (isDefined(isRebrandingEnabled)) {
      localStorage.setItem(REBRANDING_LOCAL_STORAGE_KEY, String(isRebrandingEnabled));
    }
  }, [isRebrandingEnabled]);
}
